import React, { Component } from 'react';
import {
  Card,
  Form,
  Input,
  Select,
  Button,
  message,
  Typography,
  Descriptions,
  Space,
  Tooltip,
} from 'antd-v5';
import {
  CopyOutlined,
  SearchOutlined,
  ReloadOutlined,
  ClockCircleOutlined,
  MobileOutlined,
  AppstoreOutlined,
} from '@ant-design/icons';
import { getCodeRequest } from '../../state/request/sms';
import './index.less';
import dayjs from 'dayjs';
import { handleCopyCode } from '@/utils/utils';

const { Option } = Select;
const { Text } = Typography;

class SmsCodePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      searchResult: null,
      hasSearched: false,
    };
  }

  // 应用类型选项
  systemTypeOptions = [
    { value: 7, label: '手机端' },
    { value: 1, label: '平板端' },
    { value: 2, label: '财务端' },
  ];

  // 处理查询
  handleSearch = async (values) => {
    const { phone, systemType } = values;

    if (!phone || !systemType) {
      message.error('请填写完整信息');
      return;
    }

    // 验证手机号格式
    const phoneRegex = /^1[3-9]\d{9}$/;
    if (!phoneRegex.test(phone)) {
      message.error('请输入正确的手机号');
      return;
    }

    this.setState({ loading: true });

    try {
      const params = {
        phone,
        systemType,
      };

      const response = await getCodeRequest(params);
      if (response.code === 200) {
        this.setState({
          searchResult: response.data,
          hasSearched: true,
        });
        message.success('查询成功');
      }
    } catch (error) {
      this.setState({
        searchResult: null,
        hasSearched: true,
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  // 重置查询
  handleReset = () => {
    this.form.resetFields();
    this.setState({
      searchResult: null,
      hasSearched: false,
    });
  };

  // 格式化时间戳
  formatTimestamp = (timestamp) => {
    if (!timestamp || timestamp === 0) {
      return '未发送';
    }
    return dayjs(timestamp).format('YYYY-MM-DD HH:mm:ss');
  };

  getSystemTypeLabel = (systemType) => {
    const option = this.systemTypeOptions.find((opt) => opt.value === systemType);
    return option ? option.label : systemType;
  };

  render() {
    const { loading, searchResult, hasSearched } = this.state;

    return (
      <div className='sms-code-page'>
        <div className='page-container'>
          <Card className='search-card' title='验证码查询'>
            <Form
              ref={(form) => (this.form = form)}
              name='smsCodeForm'
              onFinish={this.handleSearch}
              layout='inline'
              className='search-form'
              initialValues={{
                systemType: 7,
              }}
            >
              <Form.Item
                label='手机号'
                name='phone'
                rules={[
                  { required: true, message: '请输入手机号' },
                  { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式' },
                ]}
              >
                <Input placeholder='请输入11位手机号' maxLength={11} style={{ width: 200 }} />
              </Form.Item>

              <Form.Item
                label='应用类型'
                name='systemType'
                rules={[{ required: true, message: '请选择应用类型' }]}
              >
                <Select placeholder='请选择应用类型' style={{ width: 150 }} allowClear>
                  {this.systemTypeOptions.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item>
                <Space>
                  <Button
                    type='primary'
                    htmlType='submit'
                    loading={loading}
                    icon={<SearchOutlined />}
                  >
                    查询
                  </Button>
                  <Button onClick={this.handleReset} icon={<ReloadOutlined />}>
                    重置
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </Card>

          {hasSearched && (
            <Card className='result-card' title='查询结果' style={{ marginTop: 16 }}>
              {searchResult ? (
                <div className='result-content'>
                  <Descriptions
                    title='验证码信息'
                    bordered
                    column={1}
                    size='middle'
                    labelStyle={{
                      fontWeight: 600,
                      backgroundColor: '#fafafa',
                      width: '200px',
                    }}
                    contentStyle={{
                      backgroundColor: '#fff',
                      fontSize: '14px',
                    }}
                  >
                    <Descriptions.Item
                      label={
                        <Space>
                          <AppstoreOutlined />
                          应用类型
                        </Space>
                      }
                    >
                      <Text code style={{ fontSize: '14px', color: '#1890ff' }}>
                        {this.getSystemTypeLabel(searchResult.systemType)}
                      </Text>
                    </Descriptions.Item>
                    <Descriptions.Item
                      label={
                        <Space>
                          <ClockCircleOutlined />
                          最后发送时间
                        </Space>
                      }
                    >
                      <Text code style={{ fontSize: '14px', color: '#1890ff' }}>
                        {this.formatTimestamp(searchResult.lastSendSMSTime)}
                      </Text>
                    </Descriptions.Item>

                    <Descriptions.Item
                      label={
                        <Space>
                          <MobileOutlined />
                          验证码
                        </Space>
                      }
                    >
                      <Space>
                        <Text code style={{ fontSize: '14px', color: '#52c41a' }}>
                          {searchResult.code || '未知'}
                        </Text>
                        <Tooltip title='点击复制验证码'>
                          <Button
                            type='text'
                            icon={<CopyOutlined />}
                            onClick={() => handleCopyCode(searchResult.code || '')}
                            size='small'
                          />
                        </Tooltip>
                      </Space>
                    </Descriptions.Item>
                  </Descriptions>

                  <div className='result-summary'>
                    <Text type='secondary'>
                      <ClockCircleOutlined style={{ marginRight: 4 }} />
                      查询时间: {dayjs().format('YYYY-MM-DD HH:mm:ss')}
                    </Text>
                  </div>
                </div>
              ) : (
                <div className='no-result'>
                  <Text type='secondary'>未找到相关验证码记录</Text>
                </div>
              )}
            </Card>
          )}
        </div>
      </div>
    );
  }
}

export default SmsCodePage;
